import { LoanApplicationState } from "@lib/clients/nelo-api-client"

import { SessionData } from "./session-context"
import { StepId } from "./step-registry"

// Determine current step based on session data
export function resolveCurrentStep(sessionData: SessionData): StepId {
  // If payment options not completed, start there
  if (!sessionData.progress.paymentOptionsCompleted) {
    return StepId.PAYMENT_OPTIONS_PICKER
  }

  // If payment done but no auth token, go to signup
  if (sessionData.progress.paymentOptionsCompleted && !sessionData.progress.signupCompleted) {
    return StepId.SIGNUP_NATIVE
  }

  // If loan was rejected, show rejection screen
  if (sessionData.progress.signupCompleted && sessionData.loan.applicationStatus?.status === LoanApplicationState.REJECTED) {
    return StepId.REJECTED
  }

  // If we have auth + approved loan status + no order placed yet, go to loan options
  if (sessionData.progress.signupCompleted && !sessionData.progress.hasOrderBeenPlaced) {
    return StepId.LOAN_OPTIONS
  }

  // If order placed and approved with sufficient funds, go to idv stack
  if (sessionData.progress.hasOrderBeenPlaced) {
    return StepId.IDENTITY_VERIFICATION_STACK
  }

  // Default fallback
  return StepId.LOADING
}
